import {Inject, Injectable, Optional, PLATFORM_ID} from '@angular/core';
import {Subscription} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {REQUEST} from "../../express.tokens";
import { Request } from 'express';
import {isPlatformBrowser} from "@angular/common";

// /**
//  * Pass-through function to mark a string for translation extraction.
//  * Running `npm translations:extract` will include the given string by using this.
//  * @param s The string to extract for translation.
//  * @return Thea sme string.
//  */
export function extract(s: string) {
  return s;
}


@Injectable({
  providedIn: 'root'
})
export class I18nService {
  defaultLanguage!: string;
  supportedLanguages!: any[];
  // true una vez que se visito al menos una ruta con idioma en la URL
  // (/es/... o /en/...). Permite distinguir "primera visita sin idioma
  // establecido" (hay que detectar el del navegador) de "ya se estaba
  // navegando en un idioma" (hay que respetarlo, no volver a detectar).
  hasResolvedFromUrl = false;
  private langChangeSubscription!: Subscription;
  constructor(
    private translateService: TranslateService,
    @Optional() @Inject(REQUEST) private req: Request,
    @Inject(PLATFORM_ID) private platform: any
  ) {}

  // /**
  //  * Initializes i18n for the application.
  //  * Loads language from local storage if present, or sets default language.
  //  * @param defaultLanguage The default language to use.
  //  * @param supportedLanguages The list of supported languages.
  //  */

  init(defaultLanguage: string, supportedLanguages: any[]) {
    this.defaultLanguage = defaultLanguage;
    this.supportedLanguages = supportedLanguages;
    // Ya NO se resetea el idioma aqui (antes: this.language = '', que caia al
    // fallback de navigator.language). HandlerRedirectToLanguageComponent (rutas
    // con idioma) y RedirectPrefixComponent (rutas sin idioma) ya fijan el idioma
    // correcto por su cuenta; este reset solo competia con esa logica y a veces
    // ganaba la carrera, dejando paginas con URL /es/ mostrando ingles del navegador.
  }
  /**
   * Cleans up language change subscription.
   */
  destroy() {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  // /**
  //  * Sets the current language.
  //  * Note: The current language is saved to the local storage.
  //  * If no parameter is specified, the language is loaded from local storage (if present).
  //  * @param language The IETF language code to set.
  //  */

  set language(language: string) {
    language = isPlatformBrowser(this.platform)
      ? language ||
      this.translateService.getBrowserLang()
      : language || this.getLangFromServerSideCookie();

    let isSupportedLanguage = this.supportedLanguages.some(
      (item) => item.minLag === language
    );

    // If no exact match is found, search without the region
    if (language && !isSupportedLanguage) {
      language =
        this.supportedLanguages.find(
          (supportedLanguage) =>
            supportedLanguage.minLag.startsWith(language).minLag
        ) || '';
      isSupportedLanguage = Boolean(language);
    }

    // Fallback if language is not supported
    if (!isSupportedLanguage) {
      language = this.defaultLanguage;
    }

    if (language === this.translateService.currentLang) {
      return;
    }

    this.translateService.use(language);
  }

  getLangFromServerSideCookie() {
    if (this.req) {
      return this.req.cookies?.lang ? this.req.cookies?.lang : 'es';
    }
  }

  // /**
  //  * Gets the current language.
  //  * @return The current language code.
  //  */
  getLanguage(): {
    flag: string;
    width: string;
    height: string;
    minLag: string;
  } {
    return this.showFlagAndLenguaje([this.translateService.currentLang])[0];
  }

  showFlagAndLenguaje(langs: any) {
    // @ts-ignore
    const langWithFlags = langs.map( lang => {
      switch (lang) {
        case 'es':
          return {
            minLag: 'es',
            lang: 'Español',
            width: '25',
            height: '20',
            // flag: '../assets/img/flag-España.webp',
          };
        case 'en':
          return {
            minLag: 'en',
            lang: 'English',
            width: '23',
            height: '12',
            // flag: '../assets/img/flag-Inglaterra.webp',
          };
        default:
          break;
      }
    });
    return langWithFlags;
  }
}
